import { useRef } from 'react';
import { Button } from '../Button';
import { BgmSettings } from './BgmSettings';
import { SeSettings } from './SeSettings';
import { UserNameSettings } from './UserNameSettings';

interface SettingsModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function SettingsModal({ isOpen, onClose }: SettingsModalProps) {
  const modalRef = useRef<HTMLDivElement>(null);

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 grid place-items-center z-20"
      role="presentation"
    >
      <div
        className="absolute inset-0 bg-black/50 opacity-100 z-[-1]"
        aria-hidden="true"
        onClick={onClose}
      />

      <div
        ref={modalRef}
        role="dialog"
        aria-modal="true"
        aria-labelledby="settings-modal-title"
        className="grid place-items-center z-10 w-full md:w-auto md:max-w-900 h-full md:h-auto md:max-h-[90svh] overflow-y-auto bg-linear-to-br from-blue-600 via-indigo-600 to-purple-600 p-24 md:p-48 rounded-xl"
      >
        <div className="grid gap-16 w-full grid-auto-rows-max">
          <h2
            id="settings-modal-title"
            className="text-2xl font-bold text-white text-center"
          >
            設定
          </h2>
          <ul className="bg-white rounded-lg p-24 md:p-32 grid">
            <li className="py-24 border-b-1 border-gray-200">
              <UserNameSettings />
            </li>
            <li className="py-24 border-b-1 border-gray-200">
              <BgmSettings />
            </li>
            <li className="py-24 border-b-1 border-gray-200">
              <SeSettings />
            </li>
          </ul>

          <div className="text-center grid justify-center gap-16">
            <Button onClick={onClose} aria-label="設定を閉じる">
              閉じる
            </Button>
            <Button
              className="bg-red-600 text-white"
              onClick={() => {
                window.dispatchEvent(new CustomEvent('requestGameEnd'));
                onClose();
              }}
            >
              ゲームを終了
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
